import { Fragment } from 'react';
import styled from '@emotion/styled';
import { CharacterCard as CharacterCardSkeleton } from '~/components/atomic/Skeleton';
import CharacterCard, {
  CharacterCardClickEvent,
} from '~/components/common/CharacterCard/CharacterCard';
import { GetAllCharacterListData } from '~/types';
import { makeIndexArray } from '~/utils';

interface ExploreCharactersViewProps {
  characterList: GetAllCharacterListData[];
  handleCardClick: ({
    id,
    name,
    desc,
    type,
    image,
  }: CharacterCardClickEvent) => void;
  handleLikeClick: (id: string, isLiked: boolean) => void;
  isFetchingNextPage?: boolean;
}

export default function ExploreCharactersView({
  characterList,
  handleCardClick,
  handleLikeClick,
  isFetchingNextPage,
}: ExploreCharactersViewProps) {
  return (
    <>
      <ExploreWrapper>
        {characterList.map(
          ({
            character_id,
            character_name,
            character_image,
            character_desc,
            create_username,
            is_liked,
            liked_count,
            type,
          }) => (
            <Fragment key={character_id}>
              <CharacterCard
                id={character_id}
                image={character_image}
                name={character_name}
                desc={character_desc}
                create_username={create_username}
                is_liked={is_liked}
                liked_count={liked_count}
                handleLikeClick={handleLikeClick}
                handleCardClick={handleCardClick}
                type={type}
              />
            </Fragment>
          ),
        )}
        {isFetchingNextPage && (
          <>
            {makeIndexArray(6).map((el) => (
              <CharacterCardSkeleton key={el} />
            ))}
          </>
        )}
      </ExploreWrapper>
    </>
  );
}

const ExploreWrapper = styled.div`
  display: grid;
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 580px) {
    grid-template-columns: 1fr 1fr;
  }
`;
